import { render, staticRenderFns } from "./AddInquiry.vue?vue&type=template&id=278eece2&scoped=true&"
import script from "./AddInquiry.vue?vue&type=script&lang=js&"
export * from "./AddInquiry.vue?vue&type=script&lang=js&"
import style0 from "./AddInquiry.vue?vue&type=style&index=0&id=278eece2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278eece2",
  null
  
)

export default component.exports